var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 86,
    viewBox: "0 0 144 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.8451 2H7C4.23858 2 2 4.23858 2 7V79C2 81.7614 4.23857 84 7 84H137C139.761 84 142 81.7614 142 79V7C142 4.23858 139.761 2 137 2H103.62C100.858 2 98.6197 4.23858 98.6197 7V38.5C98.6197 41.2614 96.3811 43.5 93.6197 43.5H52.8451C50.0836 43.5 47.8451 41.2614 47.8451 38.5V7C47.8451 4.23858 45.6065 2 42.8451 2Z",
    fill: "#AFDB28",
    fillOpacity: 0.2,
    stroke: "#22A156",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4697 71.4697C10.1768 71.7626 10.1768 72.2374 10.4697 72.5303L15.2426 77.3033C15.5355 77.5962 16.0104 77.5962 16.3033 77.3033C16.5962 77.0104 16.5962 76.5355 16.3033 76.2426L12.0607 72L16.3033 67.7574C16.5962 67.4645 16.5962 66.9896 16.3033 66.6967C16.0104 66.4038 15.5355 66.4038 15.2426 66.6967L10.4697 71.4697ZM133.53 72.5303C133.823 72.2374 133.823 71.7626 133.53 71.4697L128.757 66.6967C128.464 66.4038 127.99 66.4038 127.697 66.6967C127.404 66.9896 127.404 67.4645 127.697 67.7574L131.939 72L127.697 76.2426C127.404 76.5355 127.404 77.0104 127.697 77.3033C127.99 77.5962 128.464 77.5962 128.757 77.3033L133.53 72.5303ZM11 72.75H133V71.25H11V72.75Z",
    fill: "#22A156"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3026 65H65.4901L70.6108 50.4545H73.8636L78.9915 65H76.179L72.294 53.4375H72.1804L68.3026 65ZM68.3949 59.2969H76.0653V61.4134H68.3949V59.2969Z",
    fill: "black",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUa);
export default __webpack_public_path__ + "static/media/ua.6203d6bf52376d6f319a4365d92f6071.svg";
export { ForwardRef as ReactComponent };